import hourglassIcon from '../../../../../assets/image/hourglass.svg';

const LoadingHourglass = ({className}: {className?: string}) => {
  return (
    <>
      <div
        className={`${className} p-3 h-32  rounded-lg gap-2 flex flex-col items-center justify-center`}
      >
        <img src={hourglassIcon} className="w-10" alt="pending image" />
        <span className="text-sm font-medium text-gray-700">
          درخواست در حال بررسی است
        </span>
      </div>
    </>
  );
};
export default LoadingHourglass;
